import React from 'react';
import { usePermissions } from '../contexts/PermissionContext';
import { useAuth } from '../contexts/AuthContext';
import Loader from './Loader';

const PermissionProtectedRoute = ({ children, pagePath }) => {
  const { hasPermission, loading } = usePermissions();
  const { user } = useAuth();

  // Show loading while permissions are being fetched
  if (loading) {
    return <Loader />;
  }

  // Owners have access to all pages
  if (user?.role === 'owner') {
    return children;
  }

  // Staff members need explicit permission
  if (user?.role === 'staff') {
    if (hasPermission(pagePath)) {
      return children;
    } else {
      return <PermissionDenied pagePath={pagePath} />;
    }
  }

  // Default to denied for other roles
  return <PermissionDenied pagePath={pagePath} />;
};

// Permission Denied Component
const PermissionDenied = ({ pagePath }) => {
  const pageName = getPageName(pagePath);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card border-danger">
            <div className="card-header bg-danger text-white">
              <h4 className="mb-0">
                <i className="bi bi-exclamation-triangle me-2"></i>
                Ruxsat yo'q
              </h4>
            </div>
            <div className="card-body text-center">
              <div className="mb-4">
                <i className="bi bi-lock text-danger" style={{ fontSize: '4rem' }}></i>
              </div>
              <h5 className="card-title text-danger mb-3">
                Bu sahifaga kirish ruxsati yo'q
              </h5>
              <p className="card-text mb-4">
                Siz "{pageName}" sahifasiga kirish uchun ruxsatga ega emassiz.
                Iltimos, tizim administratoriga murojaat qiling.
              </p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                <button
                  className="btn btn-primary"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Orqaga qaytish
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => window.location.href = '/'}
                >
                  <i className="bi bi-house me-2"></i>
                  Bosh sahifa
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper function to get page name from path
const getPageName = (pagePath) => {
  const pageNames = {
    '/': 'Bosh sahifa',
    '/mahsulotlar': 'Mahsulotlar',
    '/xaridlar': 'Xaridlar',
    '/kassa': 'Kassa',
    '/chiqimlar': 'Chiqimlar',
    '/suppliers': 'Taminlovchilar',
    '/kategoriyalar': 'Kategoriyalar',
    '/birliklar': 'Birliklar',
    '/mijozlar': 'Mijozlar',
    '/hisobotlar': 'Hisobotlar',
    '/omborxona': 'Omborxona',
    '/store': 'Store',
    '/qarzdorliklar': 'Qarzdorliklar',
    '/customer3': 'Customer3',
    '/customer3': 'Customer3',
    '/credits': 'Kreditlar',
    '/inventory': 'Inventarizatsiya'
  };

  return pageNames[pagePath] || pagePath;
};

export default PermissionProtectedRoute;
